import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var VideoFilledIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "clip-path",
      children: /*#__PURE__*/_jsx("polygon", {
        points: "-901.63 97.94 -891.87 97.94 -894.01 104.14 -888.63 104.14 -901.63 117.94 -899.81 107.47 -903.94 107.47 -901.63 97.94",
        fill: "none",
        clipRule: "evenodd"
      })
    })
  }), /*#__PURE__*/_jsxs("g", {
    children: [/*#__PURE__*/_jsx("rect", {
      x: "2",
      y: "4",
      width: "20",
      height: "16",
      rx: "2"
    }), /*#__PURE__*/_jsx("polyline", {
      points: "6 6 6 8 4 8",
      fill: "#fff"
    }), /*#__PURE__*/_jsx("polyline", {
      points: "6 8 6 6 8 6",
      fill: "#fff"
    }), /*#__PURE__*/_jsx("polyline", {
      points: "10 6 10 8 8 8",
      fill: "#fff"
    }), /*#__PURE__*/_jsx("polyline", {
      points: "10 8 10 6 12 6",
      fill: "#fff"
    }), /*#__PURE__*/_jsx("polyline", {
      points: "14 6 14 8 12 8",
      fill: "#fff"
    }), /*#__PURE__*/_jsx("polyline", {
      points: "14 8 14 6 16 6",
      fill: "#fff"
    }), /*#__PURE__*/_jsx("polyline", {
      points: "18 6 18 8 16 8",
      fill: "#fff"
    }), /*#__PURE__*/_jsx("polyline", {
      points: "18 8 18 6 20 6",
      fill: "#fff"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4,10H20a0,0,0,0,1,0,0v7.07a.93.93,0,0,1-.93.93H4.93A.93.93,0,0,1,4,17.07V10A0,0,0,0,1,4,10Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13,13.56a.51.51,0,0,1,0,.88l-1.25.71-.73.42a.5.5,0,0,1-.75-.44V12.87a.5.5,0,0,1,.75-.44l.73.42Z",
      fill: "#fff"
    })]
  })]
}), 'VideoFilled');